import React from 'react';
import TemplateOne from 'gatsby-core-theme/src/components/molecules/spotlights_v2/image-text/template-one';

export default (props) => <TemplateOne {...props} scrollableContent />;